import React from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import "./input.css"

export const Input = React.forwardRef((props, ref) => {
  const className = classNames("ck-input", props.className, {
    [`ck-input--${props.size}`]: props.size,
    [`ck-input--${props.variant}`]: props.variant
  })

  return <input className={className} {...props} ref={ref} />
})

Input.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  size: PropTypes.oneOf(["sm", "md", "lg", "xl"]),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  variant: PropTypes.oneOf(["inline-text", "dark"])
}
